var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-grow-1"},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"5"}},[_c('InputTabs')],1),_c('v-col',{staticClass:"pa-0",class:_vm.$style.borderVertical},[_c('OutputTabs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }